<template>
    <div>
        <modal-historico-protocolos v-if="modalHistoricoProtocolos" v-model="modalHistoricoProtocolos" @fecharModalHistoricoProtocolos="fecharModalHistoricoProtocolos"/>
        <v-tooltip top >
            <az-call-to-action
                               slot="activator"
                               dark
                               @click="abrirModalHistoricoProtocolos"
                               cssClass="botao-protocolos"
                               class="no-mobile">
                Protocolos <v-icon class="mr-0">search</v-icon>
            </az-call-to-action>
            Exibir histórico de protocolos
        </v-tooltip>
    </div>

</template>
<script>
    import ModalHistoricoProtocolos from "@/views/licitacao/detalhe/fornecedor/modal/ModalHistoricoProtocolos.vue";

    export default {
        name: 'LicitacaoFornecedorAcoesProtocolos',
        components: {ModalHistoricoProtocolos},
        data(){
            return{
                modalHistoricoProtocolos: false
            }
        },
        methods: {
            abrirModalHistoricoProtocolos() {
                this.modalHistoricoProtocolos = true
            },
            fecharModalHistoricoProtocolos() {
                this.modalHistoricoProtocolos = false
            }
        }
    }
</script>
<style lang="stylus" scoped>
.botao-protocolos
  padding-left 5px !important
  padding-right 5px !important

</style>
